<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ title }}
      </h3>
      <div class="box-tools">
        <ButtonBack />
      </div>
    </div>
    <div class="box-body">
      <div class="form-horizontal">
        <div
          class="form-group row"
          :class="{'has-error' : validations.name_km}"
        >
          <label class="col-sm-3 control-label required">
            {{ $t('field.label.team_name_km') }}
          </label>
          <div class="col-sm-9">
            <input
              v-model="team.name_km"
              :placeholder="$t('field.pla.team_name_km')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_km">
              <FiledIsRequired :msg="validations['name_km'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.name_en}"
        >
          <label class="col-sm-3 control-label required">{{ $t('field.label.team_name_en') }}</label>
          <div class="col-sm-9">
            <input
              v-model="team.name_en"
              :placeholder="$t('field.pla.team_name_en')"
              class="form-control"
              type="text"
            >
            <template v-if="validations.name_en">
              <FiledIsRequired :msg="validations['name_en'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.leader_id}"
        >
          <label class="col-sm-3 control-label required">{{ $t('field.label.team_leader') }}</label>
          <div class="col-sm-9">
            <multiselect
              v-model="team.leader_id"
              label="name"
              :class="{'multiselect__has_error': validations.leader_id}"
              :options="officers"
              :select-label="$t('multiselect.please_enter_to_select')"
              :deselect-label="$t('multiselect.please_enter_to_remove')"
              :selected-label="$t('multiselect.selected')"
              :placeholder="$t('field.pla.team_leader')"
            >
              <template slot="noOptions">
                {{ $t('string.list_is_empty') }}
              </template>
            </multiselect>
            <template v-if="validations.leader_id">
              <FiledIsRequired :msg="validations['leader_id'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.member_ids}"
        >
          <label class="col-sm-3 control-label required">{{ $t('field.pla.member') }}</label>
          <div class="col-sm-9">
            <multiselect
              v-model="team.member_ids"
              label="name"
              :class="{'multiselect__has_error': validations.member_ids}"
              :multiple="true"
              :options="officers"
              :select-label="$t('multiselect.please_enter_to_select')"
              :deselect-label="$t('multiselect.please_enter_to_remove')"
              :selected-label="$t('multiselect.selected')"
              :placeholder="$t('field.pla.member')"
              track-by="id"
            >
              <template slot="noOptions">
                {{ $t('string.list_is_empty') }}
              </template>
            </multiselect>
            <template v-if="validations.member_ids">
              <FiledIsRequired :msg="validations['member_ids'][0]" />
            </template>
          </div>
        </div>

        <div
          class="form-group row"
          :class="{'has-error' : validations.province_ids}"
        >
          <label class="col-sm-3 control-label required">{{ $t('field.label.provinces') }}</label>
          <div class="col-sm-9">
            <multiselect
              v-model="team.province_ids"
              :label="`name_${$i18n.locale}`"
              :multiple="true"
              :class="{'multiselect__has_error': validations.province_ids}"
              :select-label="$t('multiselect.please_enter_to_select')"
              :deselect-label="$t('multiselect.please_enter_to_remove')"
              :selected-label="$t('multiselect.selected')"
              :options="provinces"
              :placeholder="$t('field.pla.provinces')"
            >
              <template slot="noOptions">
                {{ $t('string.list_is_empty') }}
              </template>
            </multiselect>
            <template v-if="validations.province_ids">
              <FiledIsRequired :msg="validations['province_ids'][0]" />
            </template>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 control-label">{{ $t('field.label.reference_number') }}</label>
          <div class="col-sm-9">
            <input
              v-model="team.reference_number"
              :placeholder="$t('field.pla.reference_number')"
              class="form-control"
              type="text"
            >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-3 control-label">{{ $t('field.label.description') }}</label>
          <div class="col-sm-9">
            <textarea
              v-model="team.description"
              :placeholder="$t('field.pla.description')"
              class="form-control"
              rows="5"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-offset-3 col-sm-9">
            <template v-if="$route.params.team_uuid">
              <button
                class="btn btn-info btn-sm"
                @click="update"
              >
                {{ $t('button.update') }}
              </button>
            </template>
            <template v-else>
              <button
                class="btn btn-primary btn-sm"
                @click="store"
              >
                {{ $t('button.save') }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBack from '@/components/ButtonBack'
import FiledIsRequired from '@/components/FiledIsRequired'
export default {
  name: 'TeamForm',
  components: { FiledIsRequired, ButtonBack },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      team: {
        name_en: null,
        name_km: null,
        leader_id: null,
        member_ids: [],
        province_ids: [],
        reference_number: null,
        description: null
      },
      validations: {},
      officers: [],
      provinces: []
    }
  },
  created () {
    this.getProvinces()
    this.getOfficers()
    this.getTeam()
  },
  methods: {
    getTeam () {
      if (!this.$route.params.team_uuid) {
        return 0
      }
      this.$isLoading(true)
      this.$axios.get(process.env.VUE_APP_API + '/api/backend/teams/' + this.$route.params.team_uuid, {
        team_uuid: this.$route.params.team_uuid
      }).then(({ data }) => {
        if (data.data) {
          const {
            name_km,
            name_en,
            reference_number,
            description,
            leader,
            members,
            provinces
          } = data.data

          this.team.name_en = name_en
          this.team.name_km = name_km
          this.team.reference_number = reference_number
          this.team.description = description
          this.team.leader_id = leader ? {
            id: leader.id,
            name: `${leader.first_name} ${leader.last_name}`
          } : null
          if (Array.isArray(members) && members.length > 0) {
            this.team.member_ids = members.map((m) => {
              return {
                id: m.id,
                name: `${m.first_name} ${m.last_name}`
              }
            })
          }
          if (Array.isArray(provinces) && provinces.length > 0) {
            this.team.province_ids = provinces
          }
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    async getProvinces () {
      const { data } = await this.$axios.get(process.env.VUE_APP_API + '/api/backend/teams/provinces')
      this.provinces = await data.data
    },
    async getOfficers () {
      const { data } = await this.$axios.get(process.env.VUE_APP_API + '/api/backend/teams/officers')
      this.officers = await data.data
    },
    store () {
      this.validations = {}
      this.$isLoading(true)

      const params = Object.assign({}, this.team)

      if (params.member_ids && Array.isArray(params.member_ids) && params.member_ids.length > 0) {
        params.member_ids = params.member_ids.map(m => m.id)
      }

      if (params.province_ids && Array.isArray(params.province_ids) && params.province_ids.length > 0) {
        params.province_ids = params.province_ids.map(m => m.id)
      }

      if (params.leader_id && params.leader_id.id) {
        params.leader_id = params.leader_id.id
      }

      this.$axios.post(process.env.VUE_APP_API + '/api/backend/teams', params)
        .then(({ data }) => {
          if (data.data) {
            this.showToastr()
            this.$router.push({
              name: 'list-team'
            })
          }
        })
        .catch((error) => {
          if (error.response && error.response.status && error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    update () {
      this.validations = {}
      this.$isLoading(true)

      const params = Object.assign({}, this.team)

      params.team_uuid = this.$route.params.team_uuid

      if (params.member_ids && Array.isArray(params.member_ids) && params.member_ids.length > 0) {
        params.member_ids = params.member_ids.map(m => m.id)
      }

      if (params.province_ids && Array.isArray(params.province_ids) && params.province_ids.length > 0) {
        params.province_ids = params.province_ids.map(m => m.id)
      }

      if (params.leader_id && params.leader_id.id) {
        params.leader_id = params.leader_id.id
      }

      this.$axios.put(process.env.VUE_APP_API + '/api/backend/teams', params)
        .then(({ data }) => {
          if (data.data) {
            this.showToastr()
            this.$router.push({
              name: 'list-team'
            })
          }
        })
        .catch((error) => {
          if (error.response && error.response.status && error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  }
}
</script>

<style scoped>

</style>
